module.exports = __webpack_public_path__ + "img/booster4.ad4d53dc.png";